// remove bodycontainer classes

// declare variables

// sort api requests, construct array for apis
//// elem ref, api url, api type, loadTime, realTime
//// filter static & dynamic apis

// call api
//// cache data

// do miscelleanous stuff (calc times)

// Refresh all the owl carousels when stylesheets are loaded to fix cropped carousel bug
document.addEventListener("DOMContentLoaded", function (event) {
    [].forEach.call(document.querySelectorAll("link[data-href]"), function (elem, i) {
        elem.addEventListener("load", function () {
            var _url = elem.getAttribute("data-href");
            if (/site.css|style.min.css/i.test(_url)) {
                $(".owl-carousel.owl-loaded").each(function (j, _carousel) {
                    var w = $(this).find('.owl-stage-outer').width();
                    var w1 = $(this).find('.owl-stage-outer .owl-item').eq(0).width();
                    if (w != w1) {
                        $(_carousel).trigger("refresh.owl.carousel");
                    }
                });
            }
        });
    });
});

; var staticAPIs = [
    //"customtext",
    //"categories/CollectionWithLink",
    //"categories/CollectionWithoutLink",
    //"categories/GetCategoryMenu",
    //"categories/GetSectionListingHyperLink",
    //"categories/GetSectionProducts", // products/data changes on county change
    "search/GetSearchView",
    "SlideShows/GetSlideShow"
];

var lowPriorityElems = [
    "Wishlist/GetWishlistCountView",
    "api/SignInMyAccount",
    "api/SignInSignOut",
    "api/basket",
    "Products/GetProductCompareLink"
];

var backgroundAPIs = [], fetchStartTime = new Date();
var duplicateAPIs = {};
var forceRemoteFetch = (location.href.indexOf("flushcache") > -1);
var randomQSParam = "freshRequest";
var apiTable = [];
var perArr = [];
var psuedoPercent = 0;
var perIntervalID = 0;
var priorityElemsReady = false; // flag used to avoid priorityelemsloaded message from being called multiple times.
var localStorageEnabled = true;
var errorLogging = false;
var visualErrorLogging = false;
try { var a = window.localStorage; }
catch (c) { localStorageEnabled = false; }

if (localStorageEnabled) {
    var _errLogging = JSON.parse(localStorage.getItem("error-logging")) || null
    errorLogging = _errLogging === true ? true : false;

    var _visualErrLogging = JSON.parse(localStorage.getItem("visual-error-logging")) || null
    visualErrorLogging = _visualErrLogging === true ? true : false;
}
if (visualErrorLogging) {
    var old = console.log;
    var logger = document.createElement("div");
    logger.id = "visualLoggerDev";
    logger.setAttribute("style", "position: fixed; top: 0; left: 0; bottom: 0; right: 0; overflow: auto; z-index: 9999999; background: #fff; color: #000");
    document.body.appendChild(logger);
    console.log = function (message) {
        if (typeof message == 'object') {
            logger.innerHTML += (JSON && JSON.stringify ? JSON.stringify(message) : message) + '<br />';
        } else {
            logger.innerHTML += message + '<br />';
        }
    }
}



; $(document).ready(function () {
    var bodyClass = $('.toBeRemoved').attr('data-customclass') || "";
    $('.toBeRemoved').attr('data-id', "bodyCont").attr('class', bodyClass);


    window.totalSaasElemLength = $("div[data-saaselement][data-saasuri^='http']").length;
    window.loadedElemLen = 0;
    window.cachedElemLen = 0;
    window.totalPriorityElemLength = 0;
    window.loadedPriorityElemLength = 0;

    // if the number/threshold is defined elsewehere, use that or default to 3
    priorityElemsThreshold = (typeof (priorityElemsThreshold) === "undefined") ? 3 : priorityElemsThreshold;
    forceHideLoader = (typeof (forceHideLoader) === "undefined") ? true : forceHideLoader;
    setCategoryMenuID();
    checkDuplicateAPIs();
    setPriorityManually();
    setPriority(priorityElemsThreshold);    

    // create s3 endpoints for custom text/html elements
    $('[data-saaselementtype="Custom Text/HTML"][data-saasuri]').each(function (i, elem) {
        var _saas_uri = $(this).attr("data-saasuri");
        var customTextID = _saas_uri.split('/').pop();
        var version = (typeof SiteCssVersion !== "undefined") ? SiteCssVersion.trim() : "";
        var s3_uri = cdnURL + '/' + websiteguid + '/CustomText/' + customTextID + '.html' + version;
        $(this).attr('data-og-saasuri', _saas_uri);

        if(typeof UseS3BucketForCustomElement !== "undefined") {
            if(UseS3BucketForCustomElement) $(this).attr('data-saasuri', s3_uri);
        }
    });

    // Sort APIs based on priority
    var saasElemList = sortAPIs($("div[data-saaselement][data-saasuri^='http']"));
    $(saasElemList).each(function (index, value) {
        if ($(this).attr("data-SaaSURI") != undefined && $(this).attr("data-SaaSURI") != "undefined" && $(this).attr("data-SaaSURI") != null && $(this).attr("data-SaaSURI") != "null" && $(this).attr("data-SaaSURI") != "") {
            var _this = $(this);
            var _elmID = _this.attr('id');
            var _elType = _this.attr('data-saaselementtype') || "";
            var _subElemName = _this.attr('data-subelementname') || "";
            apiTable.push({
                order: _this.attr('data-priority'),
                type: _elType,
                name: _subElemName,
                url: _this.attr('data-SaaSURI') + _elmID,
                time: new Date().getTime(),
                source: "",
                html: ""
            });
            //console.log(_this.attr('data-priority')+"__"+_this.attr('data-SaaSURI'));
            if (debugMode) {
                updateDevGUI();
            }
        }
    });

    // unescape static html content
    $('[data-saaselementtype="Static HTML"]').each(function (i, elem) {
        var _htmlElem = $(this).find(" > .htmlElem");
        if (_htmlElem.length > 0) {
            var _html = unescape(unescape(_htmlElem.html()));
            $(elem).html(_html);
        }
    });

    // start fetching data from endpoints
    $(saasElemList).each(function (index, value) {
        var _elem = $(this);
        var saasURI_val = "";
        $(this).attr("data-loadorder", index);

        //console.log("data-SaaSURI: " + $(this).attr("data-SaaSURI"));
        if ($(this).attr("data-SaaSURI") != undefined && $(this).attr("data-SaaSURI") != "undefined" && $(this).attr("data-SaaSURI") != null && $(this).attr("data-SaaSURI") != "null" && $(this).attr("data-SaaSURI") != "") {

            var _this = $(this);
            saasURI_val = $(this).attr("data-SaaSURI");
            var saasURI_val_1 = $(this).attr("data-SaaSURI");
            saasURI_val = replaceURIkeywords(saasURI_val);
            saasURI_val = replaceRowColCount(saasURI_val, _this);

            var serviceName = getServiceName(_this);
            var indexValue = this.id + "###" + $(this).attr("data-saaselementtype");

            processAPIRequests(_this, saasURI_val, serviceName, indexValue);
        }

        $('[data-duplicate-saasuri="' + saasURI_val_1 + '"]').attr("data-duplicate-saasuri", saasURI_val);
        $('[data-duplicate-saasuri="' + saasURI_val_1 + '"]').each(function () {
            var hiddenClasses = $(this).attr('data-hiddenclass');
            if (hiddenClasses != '' && hiddenClasses != undefined && hiddenClasses != 'undefined')
                $(this).addClass(hiddenClasses);
        });

        var hiddenClasses = $(this).attr('data-hiddenclass');
        if (hiddenClasses != '' && hiddenClasses != undefined && hiddenClasses != 'undefined')
            $(this).addClass(hiddenClasses);

        var menuClass = $(this).attr('data-defaultmenu');
        if (menuClass == true || menuClass == 'true')
            $(this).addClass('defaultMenu');

        //return false;
    });

    function DecodeHTML(encodedHTML) {
        return $("<div/>").html(encodedHTML).text();
    };

    function checkDuplicateAPIs() {
        var apiCount = {};
        $("div[data-saaselement][data-saasuri^='http']").each(function (i, elem) {
            var _uri = $(this).attr("data-saasuri");
            if (typeof apiCount[_uri] == "undefined") {
                apiCount[_uri] = 1;
            } else {
                var count = apiCount[_uri];
                apiCount[_uri] = count + 1;
            }
        });

        for (var k in apiCount) {
            if (apiCount[k] > 1) {
                duplicateAPIs[k] = null;
                var _saasuri = $('[data-saasuri="' + k + '"]').eq(0).attr("data-saasuri");
                $('[data-saasuri="' + k + '"]').eq(0).attr("data-has-duplicate", true);
                $('[data-saasuri="' + k + '"]').not(':eq(0)').attr("data-is-duplicate", true).attr("data-duplicate-saasuri", _saasuri).removeAttr("data-saasuri");
            }
        }
    }

    function setCategoryMenuID() {
        $('[data-saaselementtype="Category Menu"]').each(function (i, elem) {
            var uri = $(this).attr('data-saasuri');
            var _id = $(this).attr('id') || i;
            var new_uri = uri + "?menuid=" + _id;
            $(this).attr('data-saasuri', new_uri);
        });
    }

    function setPriorityManually() {
        $('div[data-saaselement][data-saasuri^="http"]').each(function (i, elem) {
            var _this = $(this);
            var saasURI = _this.attr('data-saasuri').toLowerCase();
            var isLowPriorityElem = false;

            lowPriorityElems.forEach(function (apiStr) {
                if (!isLowPriorityElem) {
                    apiStr = apiStr.toLowerCase();
                    if (saasURI.indexOf(apiStr) > -1) {
                        isLowPriorityElem = true;
                        _this.attr("data-lowpriority", "true");
                        _this.attr("data-priority", 9999);
                    }
                }
            });
        });
    }

    function setPriority(threshold) {
        // Elements before bodycontainer will all have priority 1
        $('div[data-id="bodyCont"]').prevAll(".container,.container-fluid").find('div[data-saaselement][data-saasuri^="http"]').each(function (i, elem) {
            var _pId = $(this).attr('data-priority') || 1;
            $(this).attr('data-priority', _pId);
        });

        // Elements in bodycontainer
        var _len = $('div[data-id="bodyCont"]').find('div[data-saaselement][data-saasuri^="http"]').length;
        $('div[data-id="bodyCont"]').find('div[data-saaselement][data-saasuri^="http"]').each(function (i, elem) {
            $(this).attr('data-priority', i + 1);
        });
        // if elements in the body container are less than our pre determined threshold. set the thresold to number of elements in the body container
        threshold = (threshold <= _len) ? threshold : _len;

        // Elements after bodycontainer 
        $('div[data-id="bodyCont"]').nextAll(".container,.container-fluid").find('div[data-saaselement][data-saasuri^="http"]').each(function (i, elem) {
            $(this).attr('data-priority', (_len + i));
        });

        window.totalPriorityElemLength = $('div[data-id="bodyCont"]').prevAll(".container,.container-fluid").find('div[data-saaselement][data-saasuri^="http"][data-priority="1"]').not('[data-lowpriority="true"]').length + threshold;
    }

    function checkPriority(num, elem) {
        var _pId = elem.attr('data-priority') || num;
        elem.attr('data-priority', _pId);
    }

    // sort saas elements based on priority
    function sortAPIs(_saasElemList) {
        var _list = _saasElemList.toArray().sort(function (a, b) {
            var p1 = parseInt($(a).data("priority")) || 999;
            var p2 = parseInt($(b).data("priority")) || 999;
            return p1 - p2;
        });
        //_list.reverse();
        return _list;
    }

    function replaceURIkeywords(_uri) {
        if ($('#hidGuid').val() != undefined && $('#hidGuid').val() != "") {
            var keyword = "{productguid}";
            if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                _uri = _uri.replace(new RegExp(keyword, "ig"), $('#hidGuid').val());
            }
			
			var keyword = "{TagName}";
            if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                _uri = _uri.replace(new RegExp(keyword, "ig"), $('#hidTagName').val());
            }

            /*2019-02-14 19:37:45 Akhilesh            
              Set CategoryGuid for show category banner image on product details page*/
            keyword = "{categoryguid}";
            if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                if (navigator.cookieEnabled) {
                    if (_uri.indexOf("api/Products/GetProductsCategoryBanner") > 0 && document.URL.indexOf("/product/") > 0) {
                        keyword = "{CategoryGuid}";
                        var catguid = '';
                        var CurrentUrl = window.localStorage.getItem('CurrentUrl');
                        var catguidTemp = window.localStorage.getItem('TempCategoryGuid');
                        if (window.location.href == CurrentUrl) {
                            if (catguidTemp != '' && catguidTemp != undefined) {
                                catguid = catguidTemp;
                            }
                        }
                        else {
                            catguid = window.localStorage.getItem('CategoryGuid');
                        }

                        window.localStorage.setItem('CurrentUrl', window.location.href);
                        if (catguid == '' || catguid == null) {
                            var ProductGuid = $("#hidGuid").val();
                            var ProductUrl = _uri.split("api/Products/GetProductsCategoryBanner")[0];
                            var _url = ProductUrl + 'api/Products/GetCategoryId/' + ProductGuid;
                            $.ajax({
                                url: _url,
                                type: 'GET',
                                async: false,
                                data: {},
                                dataType: 'HTML',
                                success: function (result) {
                                    catguid = result.replace("\"", "").replace("\"", "");
                                    _uri = _uri.replace(new RegExp(keyword, "ig"), catguid);
                                    window.localStorage.setItem('TempCategoryGuid', catguid);
                                },
                                error: function (e) { }
                            });
                        }
                        else {
                            _uri = _uri.replace(new RegExp(keyword, "ig"), catguid);
                            window.localStorage.setItem('CategoryGuid', '');
                            window.localStorage.setItem('TempCategoryGuid', catguid);
                        }
                    }
                    else {
                        _uri = _uri.replace(new RegExp(keyword, "ig"), $('#hidGuid').val());
                    }
                }
                else {
                    _uri = _uri.replace(new RegExp(keyword, "ig"), $('#hidGuid').val());
                }
            }

            keyword = "{SalesFlyerGuid}";
            if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                _uri = _uri.replace(new RegExp(keyword, "ig"), $('#hidGuid').val());
            }
        }

        /* modified by sagar mandke on 06-01-2020 
        returns the URL for Resource Center Management */
        keyword = "{ResourceCenterCategoryGuid}";
        if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
            var currentLocation = window.location.href;
            var arr = currentLocation.split(new RegExp('ResourceCenterCategory', 'ig'));
            var alias_name = arr[1].indexOf('/') >= 0 ? arr[1].substring(1) : arr[1];

            if (arr.length > 0) {
                var ResourceURL = $('#globalElementsURL').val() + 'api/resourcecategories/GetResourceMasterGuid/' + alias_name;
                $.ajax({
                    url: ResourceURL,
                    type: 'GET',
                    async: false,
                    data: {},
                    dataType: 'HTML',
                    success: function (result) {
                        _uri = _uri.replace(new RegExp(keyword, "ig"), result);
                    },
                    error: function (e) {
                    }
                });
            }
        }

        if (_uri.toLocaleLowerCase().indexOf("resourcedetails/getresourcedetails") >= 0) {
            _uri = _uri + "/" + $('#IsInfoLink').val() + "/" + $("#hdnPostId").val();
        }

        if (_uri.toLocaleLowerCase().indexOf("resourcesearch/resourcesearchlist") >= 0) {
            _uri = _uri + "/" + $('#hidPageNo').val() + "/" + $("#hdnresourcesearch").val();
        }

        keyword = "{contributoralias}";
        if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
            var currentLocation = window.location.href;
            var arr = currentLocation.split(new RegExp('contributor', 'ig'));
            var alias_name = arr[1].indexOf('/') >= 0 ? arr[1].substring(1) : arr[1];
            _uri = _uri.replace(new RegExp(keyword, "ig"), alias_name);
        }

        if (_uri.toLocaleLowerCase().indexOf("dynamiccontents") >= 0) {
            var splitURL = window.location.href.split('?');
            if (splitURL.length > 1) {
                _uri = _uri + "?" + splitURL[1];
            }
        }

        if ($('#hdnVSType').val() != undefined && $('#hdnVSType').val() != "") {
            var keyword = "{doityourself}";
            if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                _uri = _uri.replace(new RegExp(keyword, "ig"), $('#hdnVSType').val());
            }
        }
        if ($('#hdnCDS').val() != undefined && $('#hdnCDS').val() != "") {
            var keyword = "{CDS}";
            if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                _uri = _uri.replace(new RegExp(keyword, "ig"), $('#hdnCDS').val());
            }
        }
        var key = $("#hdnKeyWord").val();
        if (_uri.toLocaleLowerCase().indexOf("blogs/blogsdetails") >= 0) {
            _uri = _uri + "/" + $("#hdnBlogId").val();
        }
        if (_uri.toLocaleLowerCase().indexOf("blogs/blogsdetails") <= 0 && _uri.toLocaleLowerCase().indexOf("blogs/searchblogs") <= 0 && _uri.toLocaleLowerCase().indexOf("blogs") >= 0) {
            if ($("#hdnKeyWord").val() != "" && _uri.toLocaleLowerCase().indexOf("blogs/topblogslist") <= 0 && _uri.toLocaleLowerCase().indexOf("blogs/contributors") <= 0) {
                _uri = _uri + "/search/" + $("#hdnKeyWord").val();
            }
            else {
                _uri = _uri + "/" + $("#hdnPageNo").val();
            }
        }
        if (_uri.toLocaleLowerCase().indexOf("blogs/blogsdetails") <= 0 && _uri.toLocaleLowerCase().indexOf("blogs/searchblogs") >= 0) {
            _uri = _uri + "/" + $("#hdnKeyWord").val();
        }
        if (_uri.toLocaleLowerCase().indexOf("blogs/blogsdetails") <= 0 && _uri.toLocaleLowerCase().indexOf("blogs/blogslist/writecomment") >= 0) {
            _uri = _uri + "/" + $("#hdnPostComment").val() + "/" + $("#hdnPostAuthor").val() + "/" + $("#hdnPostEmail").val() + "/" + $("#hdnPostWebsite").val() + "/" + $("#hdnCommentId").val() + "/" + $("#hdnPostId").val();
        }

        // append random param to query string
        if (_uri.indexOf("UserMenuView") > -1 || _uri.indexOf("GuestLoginView") > -1) {
            var qStr = (_uri.indexOf("?") > -1) ? "&" : "?";
            //_uri += qStr + randomQSParam + '=' + Date.now();
        }

        // video list 
        // if (_uri.toLocaleLowerCase().indexOf("videodetails".toLocaleLowerCase()) >= 0) {
        //     _uri = _uri + "/" + $("#hdnAliasName").val();
        // }
        if (_uri.toLocaleLowerCase().indexOf("product-videos/blog".toLocaleLowerCase()) >= 0) {
            _uri = _uri + "/" + $("#hdnAliasName").val();
        }
        if (_uri.toLocaleLowerCase().indexOf("BreadCrumbs/GetBreadCrumbs".toLocaleLowerCase()) >= 0) {
            var websiteurl = document.URL;
            var Webhost = document.location.origin;
            _uri = _uri + "?baseUrl=" + websiteurl + "&hostName=" + Webhost;
        }
        return _uri;
    }

    function replaceRowColCount(_uri, _this) {
        var keyword = "{row}";
        if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
            _uri = _uri.replace(new RegExp(keyword, "ig"), _this.attr('data-rowcount'));
        }
        keyword = "{column}";
        if (_uri.toLocaleLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
            _uri = _uri.replace(new RegExp(keyword, "ig"), _this.attr('data-columncount'));
        }
        return _uri;
    }

    function getServiceName(_sElem) {
        if (_sElem.attr('data-servicename') != undefined && _sElem.attr('data-servicename') != null && _sElem.attr('data-servicename') != 'undefined') {

            var serviceNameAttr = _sElem.attr('data-servicename');

            if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_configuration') > -1)
                return 'SaaS_Configuration_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_globalelement') > -1)
                return 'SaaS_GlobalElements_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_reviewmanagement') > -1)
                return 'SaaS_ReviewManagement_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_product') > -1)
                return 'SaaS_Product_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_order') > -1)
                return 'SaaS_Order_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_htmlconfigurator') > -1)
                return 'SaaS_HTMLConfigurator_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_virtualsample') > -1)
                return 'SaaS_VirtualSample_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().indexOf('saas_user') > -1)
                return 'SaaS_Users_Microservice';
            else if (serviceNameAttr.toLocaleLowerCase().lastIndexOf('saas_bask') > -1)
                return "SaaS_Basket_Microservice";
            else if (serviceNameAttr.toLocaleLowerCase().lastIndexOf('saas_catalog') > -1)
                return "SaaS_Catalog_Microservice";
            //else if (serviceNameAttr.toLocaleLowerCase().lastIndexOf('saas_campaign') > -1)
            //    return "SaaS_Campaign_Microservice";
            else if (serviceNameAttr.toLocaleLowerCase().lastIndexOf('saas_campaign') > -1)
                return "dWizSaaS_Campaign_Microservice";
        }
        return "";
    }

    function stripRandomParam(_url) {
        if (_url.indexOf("?") < 0) return _url;
        if (_url.indexOf(randomQSParam) < 0) return _url;

        var splitURL = _url.split("?");
        var paramsArr = splitURL[1].split("&");
        for (var i = paramsArr.length - 1; i >= 0; i--) {
            var param = paramsArr[i].split("=")[0];
            if (param === randomQSParam) {
                paramsArr.splice(i, 1);
            }
        }
        _url = splitURL[0] + "?" + paramsArr.join("&");
        return _url;
    }

    function isStaticAPI(_apiURL, staticAPIs) {
        for (var x = 0; x < staticAPIs.length; x++) {
            if (_apiURL.indexOf(staticAPIs[x]) > -1)
                return true;
        }
        return false;
    }

    function processAPIRequests(_elem, _apiURL, _serviceName, _indexValue) {
        if (_apiURL != "") {
            apiLoaded(_elem, "init", _apiURL, false);

            var _isStaticAPI = isStaticAPI(_apiURL, staticAPIs);
            //var _isDuplicateAPI = isDuplicateAPI(_apiURL, _elem);

            if (_isStaticAPI && !forceRemoteFetch && localStorageEnabled) {
                // Check avaibility in local storage & retrieve html data
                var loadFromLS = getLocalStorageAvailabilty(_elem, _apiURL, _serviceName, _indexValue);
                if (loadFromLS) {
                    apiLoaded(_elem, "done_success", _apiURL, true, true, loadFromLS);
                    setHTML(loadFromLS, _indexValue);
                    //console.log(_apiURL + " loaded from cache.");
                    backgroundAPIs.push({ api: _apiURL, service: _serviceName });

                    var _attr = _elem.attr('data-has-duplicate');
                    if (typeof _attr !== typeof undefined && _attr !== false) {
                        $('[data-duplicate-saasuri="' + _apiURL + '"]').each(function (elem, i) {
                            setCloneHTML($(this), loadFromLS, _apiURL);
                        });
                    }

                } else {
                    fetchAPI({ elem: _elem, api: _apiURL, service: _serviceName, indexValue: _indexValue, static: true, updateDom: true });
                }

            } else {
                // Remote Fetch
                fetchAPI({ elem: _elem, api: _apiURL, service: _serviceName, indexValue: _indexValue, static: false, updateDom: true });
            }
        }
    }

    function fetchAPI(fetchOptions) {
        var obj1 = {};
        var currentURL = window.location.href; 
        obj1.MicroserviceName = fetchOptions.service;
        if (fetchOptions.api.indexOf('GetBreadCrumbs') > -1) {
            //set categoryguid in header for breadcrumb
            var categoryGuid = "";
            var name = "CategoryGuid" + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    categoryGuid = c.substring(name.length, c.length);
                }
            }
            if (typeof categoryGuid == "undefined" || categoryGuid == undefined || categoryGuid == "undefined") {
                categoryGuid = "";
            }
            obj1.headers = {
                Accept: "text/html", "LanguageGuid": languageuid, "WebSiteGuid": websiteguid, "DefaultLanguageGuid": defaultlanguageguid, "CurrencyGuid": currencyguid, "DefaultCurrencyGuid": defaultcurrencyguid, "CurrencySymbol": currencysymbol, "CookieDetails": cookiedetails, "CurrentURL": currentURL, "CategoryGuid": categoryGuid
            };
            //set categoryguid in header for breadcrumb
        }
        else {
            obj1.headers = {
                Accept: "text/html", "LanguageGuid": languageuid, "WebSiteGuid": websiteguid, "DefaultLanguageGuid": defaultlanguageguid, "CurrencyGuid": currencyguid, "DefaultCurrencyGuid": defaultcurrencyguid, "CurrencySymbol": currencysymbol, "CookieDetails": cookiedetails
            };
        }
        obj1.url = fetchOptions.api;
        obj1.type = 'GET';
        obj1.dataType = 'html';
        obj1.OnSuccess = function (data) {
            if (errorLogging) console.log(data);
            if (fetchOptions.elem) {
                var _attr = fetchOptions.elem.attr('data-has-duplicate');
                if (typeof _attr !== typeof undefined && _attr !== false) {
                    var _selector = '[data-duplicate-saasuri="' + fetchOptions.api + '"]';
                    var _dElems = $(_selector);
                    _dElems.each(function () {
                        setCloneHTML($(this), data, fetchOptions.api );
                    });
                }
            }

            if (fetchOptions.updateDom) {
                setHTML(data, fetchOptions.indexValue);
                apiLoaded(fetchOptions.elem, "done_success", fetchOptions.api, true, false, data);
            }
            if (fetchOptions.static) {
                setCache(fetchOptions.api, data);
            }
            if (!fetchOptions.updateDom && fetchOptions.static) {
                apiCached(fetchOptions.api);
            }
        };
        obj1.OnError = function (msg) {
            if (errorLogging) console.log(msg);
            if (fetchOptions.updateDom) {
                apiLoaded(fetchOptions.elem, "done_error", fetchOptions.api, true, false, "");
            } else {
                apiCached(fetchOptions.api);
            }
        };
        obj1.statusCode = {};
        callApi(obj1);
    }

    function fetchAPIsToCache() {
        if (debugMode) {
            console.log(backgroundAPIs);
        }
        backgroundAPIs.forEach(function (apiObj, i) {
            fetchAPI({
                api: apiObj.api,
                service: apiObj.service,
                updateDom: false,
                static: true
            });
        });
    }

    function getLocalStorageAvailabilty(_elem, _apiURL, _serviceName, _indexValue) {
        if (typeof (Storage) !== "undefined") {
            //_apiURL = stripRandomParam(_apiURL);
            var content = getCache(_apiURL);
            return (content == "") ? false : content;
        } else {
            return false;
        }
    }

    function getCache(apiURL) {
        if (localStorage.getItem(apiURL) === null || localStorage.getItem(apiURL) === undefined) {
            return false;
        }
        var obj = JSON.parse(localStorage.getItem(apiURL));
        var dt = new Date();
        if (obj.expiry <= Date.parse(dt)) {
            localStorage.removeItem(apiURL);
            return "";
        }
        return obj.value;
    }

    function setCache(apiURL, data) {
        var dt = new Date();
        var expiry = Date.parse(dt) + (15 * 60 * 1000); // 15 minutes
        var obj = {
            value: data,
            expiry: expiry
        }
        localStorage.setItem(apiURL, JSON.stringify(obj));
    }

    function genSvgImg(_html) {
        // expected pattern: @svg_100_100_#f1f1f1_plchldr@

        var pattern = /\@svg_([^\@]+)_plchldr\@/g;
        var matches = ((_html || '').match(pattern) || []);
        matches.forEach(function (str) {
            var imgAttribs = str.match(/@svg_(.*)_plchldr@/)[1].split("_");
            var w = imgAttribs[0] || 300;
            var h = imgAttribs[1] || 300;
            var c = imgAttribs[2] || "#cccccc";
            var s = "data:image/svg+xml;charset=utf-8,<svg xmlns='http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg' width='" + w + "' height='" + h + "'><rect width='100%' height='100%' fill='" + c + "'%2F><%2Fsvg>";
            //_html = _html.replace(str, s);
        });
        return _html;
    }

    function genRandomId () {
        return Math.floor((Math.random() * 100000000) + 1);
    }

    function setHTML(_htmlData, _indexVal) {

        // replace random id placeholder
        var _randomID = genRandomId();
        _htmlData = _htmlData.replace(/#randomno#/g, _randomID);

        var arr = _indexVal.split("###");
        if (arr[1].indexOf("Custom Text") != -1) {
            var _staticImgURL = [cdnURL, websiteguid, 'StaticImages'].join("/") + "/";

            _htmlData = _htmlData.replace(/@SaaS_Web_Microservice_URL[/]/g, (location.protocol + '//' + location.host + '/'));
            _htmlData = _htmlData.replace(/@Static_Image_URL[/]?/g, _staticImgURL);
            _htmlData = _htmlData.replace(/@CDN_URL[/]?/g, cdnURL);
            _htmlData = genSvgImg(_htmlData);// generate svg image placeholders

            _htmlData = $("<div/>").html(_htmlData).text();
        }

        // use data-render-target to render the html to user specified html element
        var _targetSelector = $('#' + arr[0]).data('render-target') || "";
        var renderedToTarget = false;
        if(_targetSelector.length > 0) {
            console.log("Attempting to render to " + _targetSelector);
            var _target = $(_targetSelector);
            if(_target.length > 0) {
                _target.html(_htmlData);
                renderedToTarget = true;
                console.log("Rendered to: " + _targetSelector);
            } else {
                console.warn("Render target: '" + _targetSelector + "' not found. Rendering to: '#" + arr[0] + "' instead.")
            }
        }
        if(!renderedToTarget) {
            $('#' + arr[0]).html(_htmlData);
        }
    };

    function setCloneHTML(elem, data, apiURL) {
        var indexVal = elem.attr("id") + "###" + elem.attr("data-saaselementtype");
        elem.attr("data-apiloaded", "done_success");
        elem.attr("data-priority", 9999);
        setHTML(data, indexVal);
        apiLoaded(elem, 'done_success', apiURL, true, false, data);
    }

    function apiLoaded(_elem, status, apiURL, finished, loadedFromLS, html) {
        $(_elem).attr('data-apiLoaded', status);
        var priorityId = $(_elem).attr('data-priority');

        if (finished) {
            window.loadedElemLen++;
            var _elmID = $(_elem).attr("id");
            var _in = apiTable.findIndex(function (x) {
                return x.url == (apiURL + _elmID);
            });
            var _t = 0;
            if (_in > -1) {
                _t = ((new Date().getTime()) - apiTable[_in].time) / 1000;
                apiTable[_in].time = _t;
                apiTable[_in].html = html;
                apiTable[_in].source = (loadedFromLS) ? "LocalStorage" : "Remote";
            }
            if (debugMode) {
                updateDevGUI();
            }


            var msg = "[t:" + _t.toFixed(2) + "s] [P:" + priorityId.toString().padStart(2, "0") + "] [" + window.loadedElemLen.toString().padStart(2, "0") + "/" + window.totalSaasElemLength + "] - " + apiURL + " loaded";
            msg += (loadedFromLS) ? " from cache" : "";
            if (debugMode) {
                console.log(msg);
            }

            if (priorityId <= priorityElemsThreshold) {
                window.loadedPriorityElemLength++;
                updatePageLoader(false);
            }
            if ((window.loadedPriorityElemLength == window.totalPriorityElemLength && !priorityElemsReady) || forceHideLoader) {
                priorityElemsReady = true;
                updatePageLoader(true);
                if (debugMode) {
                    console.log("Priority elements loaded");
                }
            }

        }

        if (window.loadedElemLen == window.totalSaasElemLength) {
            var endFetchTime = (new Date()) - fetchStartTime;
            window.prerenderReady = true;
            console.log('%c ' + endFetchTime + "s | window.prerenderReady = true", 'background: #bada55; color: #000000');
            fetchAPIsToCache();
            console.log('%c ' + endFetchTime + "s | Remote APIs + Cached APIs loaded.", 'background: #bada55; color: #000000');
            updateDevGUI();
        }
    }

    function apiCached(apiURL) {
        if (debugMode) console.log(apiURL + " cached");
        window.cachedElemLen++;
        if (window.cachedElemLen == backgroundAPIs.length) {
            var endFetchTime = (new Date()) - fetchStartTime;
            if (debugMode) {
                console.log('%c ' + endFetchTime + "s | Remote APIs cached.", 'background: #bada55; color: #000000');
            }
        }
    }



    function updatePageLoader(ready) {
        var _percent = Math.round((window.loadedPriorityElemLength / window.totalPriorityElemLength) * 100);
        _percent = Math.min(_percent, 100);
        //console.log("Percent:" + _percent);
        $('.page-load-container .message').text(_percent + "%");
        $('.page-load-container .bar').css("width", _percent + "%");
        //perArr.push(_percent);

        if (ready) {
            $('.page-load-container .message').text("100%");
            $('.page-load-container .bar').css("width", "100%");
            $('.page-load-container').fadeOut();
            clearInterval(perIntervalID);
        }
    }

    function setOwlLazySrc() {
        $(".owl-carousel.owl-loaded img.owl-lazy").each(function (i, elem) {
            //$(this).attr("src", $(this).attr("data-src"));
            //$(this).removeClass("owl-lazy");
        });
    }

    setOwlLazySrc();
    //setInterval(function(){
    setOwlLazySrc();
    //},500);  

    $(document).on("click", "#devGUIContainer th[sort]", function () {
        var isAsc = !($(this).hasClass("desc"));
        var _class = isAsc ? "desc" : "asc";
        $(this).attr("class", _class);
        var sortBy = $(this).attr("sort");
        apiTable.sort(function (a, b) {
            var _a = a[sortBy],
                _b = b[sortBy];

            if (sortBy == "order") {
                _a = parseInt(_a);
                _b = parseInt(_b);
            }

            if (isAsc) {
                if (_a > _b) return -1;
                if (_a < _b) return 1;
            } else {
                if (_a > _b) return 1;
                if (_a < _b) return -1;
            }
            return 0;
        });
        updateDevGUI();
    });

    $(document).on("click", "#devGUIToggle", function () {
        $("#devGUIContainer").toggle();
    });
});



/// <summary>
/// Author  : Rohan Gaikwad
/// Date    : 07/11/2017
/// Scope   : Find an asynchronously added element on the page
/// Version : 0.2b
/// </summary> 
; (function ($, window, document, undefined) {

    $.fn.findAsyncElem = function (options) {
        return this.each(function () {
            var _this = this;
            var intervals = [];
            var foundCounter = 0;

            // override default settings
            var settings = $.extend({
                target: "",
                interval: 100,
                startTime: new Date().getTime(),
                timeOut: 60 * 1000,
                debugMode: false
            }, options);

            settings.target = (Array.isArray(settings.target)) ? settings.target : settings.target.split(",");
            for (var i = 0; i < settings.target.length; i++) {
                if (settings.target[i] == "" || settings.target[i] == undefined || settings.target[i] == null) {
                    settings.target.splice(i, 1);
                    i--;
                }
            }


            for (var i = 0; i < settings.target.length; i++) {

                settings.timeOut = Math.min(settings.timeOut, 120 * 1000);
                var trgt = settings.target[i];
                var targetLength = $(_this).find(trgt).length;

                // bind all the variables to the function
                (function (i, trgt, targetLength, intervals) {
                    intervals.push(
                        setInterval(function () {
                            var _time = new Date().getTime();

                            // stop searching if we exceed the timeout duration
                            if (_time > (settings.startTime + settings.timeOut)) {
                                clearInterval(intervals[i]);
                                if (settings.error) {
                                    settings.error.call(this, "Timeout. '" + trgt + "' couldn't be found.");
                                }
                            }

                            if (targetLength > 0) {
                                _findAsyncFound(i, _time, trgt);
                            } else {
                                targetLength = $(_this).find(trgt).length;
                            }
                        }, settings.interval)
                    );
                })(i, trgt, targetLength, intervals);
            }

            function _findAsyncFound(_intervalID, _time, trgt) {
                clearInterval(intervals[_intervalID]);
                foundCounter++;
                if (settings.debugMode) {
                    console.log("Found " + trgt);
                }
                if (foundCounter == settings.target.length) {
                    if (settings.success) {
                        settings.success.call(this, (_time - settings.startTime) / 1000 + " ms");
                    }
                }
            }

        });
    }

})(jQuery, window, document);

















var debugMode = false;
var debugGUI = false;
if (localStorageEnabled) {
    var _debugMode = localStorage.getItem("debugMode");
    if (_debugMode != null && _debugMode != undefined) {
        debugMode = JSON.parse(_debugMode);
        var toggleBtn = createElem("span", ["id~devGUIToggle", "style~ position: fixed; z-index: 10; top: 0; right: 0;", "class~ fa-stack fa-lg"]);
        var ico1 = createElem("i", ["class~ fa fa-stop fa-stack-2x"]);
        var ico2 = createElem("i", ["class~ fa fa-gear fa-stack-1x fa-inverse"]);
        toggleBtn.appendChild(ico1);
        toggleBtn.appendChild(ico2);
        document.body.appendChild(toggleBtn);
    }
    var _debugGUI = localStorage.getItem("debugGUI");
    if (_debugGUI != null && _debugGUI != undefined) {
        debugGUI = JSON.parse(_debugGUI);
        var guiDIVstyle = "style~ position: absolute; z-index: 10; top: 0; left: 0;";
        if (!debugGUI) {
            guiDIVstyle += " display:none;"
        }
        var guiDIV = createElem("div", ["id~devGUIContainer", guiDIVstyle]);
        var devApiList = createElem("div", ["class~apiList"]);
        guiDIV.appendChild(devApiList);
        document.body.appendChild(guiDIV);
    }
    var _forceRemote = localStorage.getItem("forceRemoteFetch");
    if (_forceRemote != null && _forceRemote != undefined) {
        forceRemoteFetch = JSON.parse(_forceRemote);
    }
}

function createElem(elem, attr) {
    var _elm = document.createElement(elem);
    attr.forEach(function (_attr, i) {
        var _a = _attr.split("~");
        _elm.setAttribute(_a[0], _a[1]);
    });
    return _elm;
}

function updateDevGUI() {
    var _apiArr = [].concat(apiTable);

    if ($("#devGUIContainer .apiList tbody").length < 1) {
        $("#devGUIContainer .apiList").html('<table class="table table-sm table-striped table-success text-left"><thead><tr><th>#</th><th sort="order">Priority</th><th sort="url">Service</th><th sort="type">Type</th><th sort="name">Name</th><th sort="time">Time</th><th sort="source">Source</th><th>Response</th></tr></thead><tbody></tbody></table>');
    } else {
        $("#devGUIContainer .apiList tbody").empty();
    }
    _apiArr.forEach(function (api, i) {
        var patt = /\/\/(.*?)(beta|live|alpha|\.)/;
        var _serviceName = (api.url.indexOf("localhost") > -1) ? "local" : api.url.match(patt)[1];
        var _html = "<tr>";
        _html += '<td>' + (i + 1).toString().padStart(2, "0") + '.</td>';
        _html += '<td align="right">' + api.order + '</td>';
        _html += '<td>' + _serviceName + '</td>';
        _html += '<td>' + api.type + '</td>';
        _html += '<td>' + api.name + '</td>';
        _html += '<td>' + api.time + '</td>';
        _html += '<td>' + api.source + '</td>';
        _html += '<td align="center"><i class="fa fa-eye" onclick=\'apiResponse("' + api.url + '")\'></i></td>';
        _html += '</tr>';
        $(_html).appendTo('#devGUIContainer .apiList tbody');
    })
}

function apiResponse(apiURL) {
    var i = apiTable.findIndex(function (x) {
        return x.url == apiURL;
    });
    var _rclass = "api_" + Math.floor((Math.random() * 100000) + 1);
    popupV2({
        content: '<pre class="m-0 p-3 text-muted bg-dark">' + apiTable[i].type + " - " + apiTable[i].name + '</pre><pre class="code m-0 p-3 text-light bg-dark" style="white-space:pre-wrap;"></pre>',
        size: "lg",
        classes: _rclass,
        shown: function () {
            debugger;
            var _sel = "." + _rclass + " pre.code";
            $("." + _rclass + " .modal-header").addClass("d-none");
            $("." + _rclass + " .modal-body").addClass("p-0");
            $(_sel).text(apiTable[i].html);
        }
    });
}